"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeCover = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mixins_1 = require("../../../themes/mixins");
var styled_1 = require("./styled");
var useScreenWidth_1 = require("../../../utils/customHooks/useScreenWidth");
var Typo2_1 = require("../Typo2");
var Buttons_1 = require("../Buttons");
var themes_1 = require("../../themes");
var ImageSwitcher_1 = require("./comps/ImageSwitcher");
var WrapperContentSection_1 = require("./comps/WrapperContentSection");
var styled_components_1 = require("styled-components");
var HomeCover = function (_a) {
    var title = _a.title, 
    // subtitle,
    desc = _a.desc, CTALink = _a.CTALink, 
    // customComp,
    coverImagesConfig = _a.coverImagesConfig, _b = _a.variant, variant = _b === void 0 ? "default" : _b;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var isDesktop = screenWidth > (0, mixins_1.getBreakPoint)("md");
    var navigate = (0, react_router_dom_1.useNavigate)();
    var theme = (0, styled_components_1.useTheme)();
    var _CoverImages = coverImagesConfig.every(function (c) { return typeof c === "string"; })
        ? coverImagesConfig
        : coverImagesConfig.map(function (c) { return c.publicUrl; });
    var deskTop = react_1.default.createElement(styled_1.StyledHomeCover, { variant: variant },
        react_1.default.createElement(WrapperContentSection_1.WrapperContentSection, { theme: theme },
            react_1.default.createElement("div", { style: { position: "relative", height: '100%', borderRadius: '1rem', display: 'flex', alignItems: 'center', padding: '1.6rem' } },
                react_1.default.createElement("div", null,
                    react_1.default.createElement(Typo2_1.UI_DISPLAY_SM, null, title),
                    react_1.default.createElement(Typo2_1.UI_BODY_SEMIBOLD_DF, { style: { color: themes_1.colors.grey80, marginTop: "0.8rem" } }, desc)),
                CTALink && react_1.default.createElement(Buttons_1.ButtonTertiary, { style: { position: "absolute", bottom: "1.6rem", left: "1.6rem" }, iconSize: "S", icon: (CTALink === null || CTALink === void 0 ? void 0 : CTALink.icon) || "ArrowRight", onClick: function () { return navigate((CTALink === null || CTALink === void 0 ? void 0 : CTALink.url) || CTALink); } }, CTALink === null || CTALink === void 0 ? void 0 : CTALink.text))),
        react_1.default.createElement(ImageSwitcher_1.ImageSwitcher, { images: _CoverImages, theme: theme }));
    var mobile = react_1.default.createElement(styled_1.StyledMobileHomeCover, { id: "StyledMobileHomeCover", theme: theme, variant: variant },
        react_1.default.createElement(ImageSwitcher_1.ImageSwitcher, { images: _CoverImages, isDesktop: false, theme: theme }),
        react_1.default.createElement(styled_1.StyledMobileContentWrapper, null,
            react_1.default.createElement("div", { style: { alignContent: "end", height: '100%', gap: "1.6rem" } },
                react_1.default.createElement("div", { style: { color: "white" } },
                    react_1.default.createElement(Typo2_1.UI_DISPLAY_SM, null, title),
                    variant !== "small" && react_1.default.createElement(Typo2_1.UI_BODY_SEMIBOLD_SM_DF, { style: { marginTop: "0.8rem", opacity: 0.8 } }, desc)),
                CTALink && react_1.default.createElement(Buttons_1.ButtonSecondaryCompact, { responsive: true, style: { marginTop: '1.6rem' }, iconSize: "S", icon: (CTALink === null || CTALink === void 0 ? void 0 : CTALink.icon) || "ArrowRight", onClick: function () { return navigate((CTALink === null || CTALink === void 0 ? void 0 : CTALink.url) || CTALink); } }, CTALink === null || CTALink === void 0 ? void 0 : CTALink.text))));
    return (isDesktop ? deskTop : mobile);
};
exports.HomeCover = HomeCover;
